import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../../../../../../CurrentUserStore';
import { findLinkBy } from '../../../../../../../../../Links';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';
import {
  SaveAndEditing,
  Creating,
  Publishing as PublishingT,
  ConfirmingCancelFromPublish,
  ConfirmingCancelFromCreate,
  ConfirmingCancelFromSaveAndEdit,
} from '../../../../../LearningCollectionPreviewStore/Types';
import BaseLayout from '../../../../../../shared/SaveActions/BaseLayout';
import CancelButton from '../../../../../../shared/SaveActions/CancelButton';
import CreateWithoutPublishingButton from '../../../../../../shared/SaveActions/CreateWithoutPublishingButton';
import PublishButton from '../../../../../../shared/SaveActions/PublishButton';
import OpenModal from './OpenModal';
import OtherCreateOptions from './OtherCreateOptions';

interface Props {
  state:
    | PublishingT
    | Creating
    | SaveAndEditing
    | ConfirmingCancelFromPublish
    | ConfirmingCancelFromCreate
    | ConfirmingCancelFromSaveAndEdit;
}

function Publishing({ state }: Props) {
  const actionButtons = findLinkBy({ rel: 'publish' }, currentUserStore.links)
    .map(() => (
      <div className="flex items-center">
        <PublishButton onClick={() => previewStore.startPublishing()} />
        <OtherCreateOptions />
      </div>
    ))
    .getOrElse(() => (
      <div className="flex items-center">
        <CreateWithoutPublishingButton onClick={() => previewStore.startCreating()} />
        <OtherCreateOptions showCreateWithoutPublishing={false} />
      </div>
    ));

  return (
    <BaseLayout>
      <CancelButton onClick={() => previewStore.showCancelConfirmation()} />
      {actionButtons}
      <OpenModal
        isOpen={true}
        state={state}
        onClose={() => previewStore.wait()}
        onSave={() => previewStore.save()}
      />
    </BaseLayout>
  );
}

export default observer(Publishing);
